import { render, staticRenderFns } from "./web-content.vue?vue&type=template&id=24fa0429&scoped=true&"
import script from "./web-content.vue?vue&type=script&lang=js&"
export * from "./web-content.vue?vue&type=script&lang=js&"
import style0 from "./web-content.vue?vue&type=style&index=0&id=24fa0429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa0429",
  null
  
)

export default component.exports